module.exports = __webpack_public_path__ + "media/images/swimming-pool-9a8bd7fe5b826ad654596e944a40e963.jpg";